import { navigateToBrowsePageWithQueryParams } from './navigateToBrowsePageWithQueryParams'
import refineSearchState from './refineSearchState'

const refineSearchAndNavigateToBrowsePageWithQueryParams = (
  taxonomy,
  fromFacetOrLocationPage = false
) => {
  const refinedSearchState = refineSearchState(
    { taxonomy },
    fromFacetOrLocationPage
  )
  navigateToBrowsePageWithQueryParams(refinedSearchState)
}

export default refineSearchAndNavigateToBrowsePageWithQueryParams
